<template>
    <label class="relative inline-flex items-center cursor-pointer">
        <input type="checkbox" v-model="checked" class="sr-only peer" @change="change" :checked="checked">
        <div class="w-11 h-6 bg-grey-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full 
        peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1/2 after:-translate-y-1/2
        after:left-[2px] after:bg-white after:border-grey-300 after:border after:rounded-full after:size-5 after:transition-all peer-checked:bg-primary-400"></div>
        <span class="ml-3 text-sm font-medium text-grey-900" v-if="label">{{label}}</span>
    </label>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';

    export default defineComponent({
        name: 'slide-toggle',
        props: {
            modelValue: Boolean,
            label: String
        },
        data() {
            return {
                checked: this.modelValue as boolean
            };
        },
        methods: {
            change(): void {
                this.$emit('update:modelValue', this.checked);
            }
        }
    });
</script>
